// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3SBA6","requiredAsterisk":"Info_requiredAsterisk__1hwX0"};